// extracted by mini-css-extract-plugin
export var Collapsible = "style-module--Collapsible--b3967";
export var content = "style-module--content--5bd9f";
export var def = "style-module--def--58c05";
export var noBorder = "style-module--noBorder--d643c";
export var plusMinus = "style-module--plusMinus--3c3f5";
export var title = "style-module--title--5aae2";